import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import AppContainer from '../Appcontainer'
import store from '../../store'
import { Provider } from 'react-redux'
import Login from '../../views/pages/LoginPage/Login'
import Payment from '../../views/pages/Payment/Payment'
import Kyc from '../../views/pages/Kyc/Kyc'
import { Navigate } from 'react-router-dom/dist'
import Otp from '../../views/pages/Otp/Otp'
import ForgotPassword from '../../views/pages/forgotPassword/forgotPassword'
import ChangePassword from '../../views/pages/ChanagePasword/changePassword'
import Docuseal from '../../views/pages/Docuseal/docuseal'

// import ToastMessage from "../../lib/common/ToastMessage";
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

const AppRouter = () => {
  return (
    <div>
      <Provider store={store}>
        <BrowserRouter basename='/'>
          <ScrollToTop />
          <Routes>
            <Route path='/' element={<Login />} />
            <Route path='/Payment/:slug' element={<Payment />} />
            <Route path='/kyc/:slug' element={<Kyc />} />
            <Route path='/otp' element={<Otp />} />
            <Route path='forgot' element={<ForgotPassword />} />
            <Route path='/change-password' element={<ChangePassword />} />
            <Route path='/change-password' element={<ChangePassword />} />
            <Route path='/Sign/:id' element={<Docuseal />} />
            <Route path='*' element={<Navigate to='/' />} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </div>
  )
}

export default AppRouter
